<template>
  <div class="OrderForm">
    <Dialog :showAppDia.sync="showAppDia"></Dialog>
    <Dialog :reloadorder.sync="reloadorder"></Dialog>
    <Customer-Order :bindOrder.sync="bindOrder" :textDesc="textDesc" @bindVirualSku="bindVirualSku"
      @updataItem="updataItem(arguments)"></Customer-Order>
    <el-dialog :title="noteOrderInfo ? $t('other.a673') + noteOrderInfo.orderId : $t('other.a674')"
      :visible.sync="noteOrderDia" width="40%">
      <div>
        <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }" :placeholder="$t('other.a675')"
          v-model="msgToStore"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="noteOrderDia = false">{{ $t('other.a5') }}</el-button>
        <el-button v-if="noteOrderInfo" type="primary" @click="confirmNoteOrder()">{{ $t('other.a274') }}</el-button>
        <el-button v-if="!noteOrderInfo" type="primary" @click="massNoteOrder()">{{ $t('other.a274') }}</el-button>
      </span>
    </el-dialog>
    <div v-show="isNotify" class="notify-boxw">
      <div style="font-weight: bold; margin-bottom: 10px;">{{ $t('other.a963') }}</div>
      <span style="margin-right: 20px;">{{ $t('other.a964') }}{{ targetList.length }}{{ $t('other.a965') }}{{
        successTotal
      }}</span>
      <i class="el-icon-loading"></i>
    </div>

    <!-- 绑定 -->
    <el-dialog :title="ttpTu" :visible.sync="bindTuAn" width="80%">
      <el-select v-model="getDataList.galleryType" @change="chooseTu()" style="margin-right: 10px;">
        <el-option label="定制图库" :value="0">
        </el-option>
        <el-option label="平台热图" :value="1">
        </el-option>
      </el-select>
      <el-select v-model="getDataList.layoutType" @change="chooseTu()">
        <el-option label="字母版" :value="0">
        </el-option>
        <el-option label="动漫版" :value="1">
        </el-option>
      </el-select>
      <div class="customerPopBox">
        <el-table ref="multipleTable" :data="TuAnItemList" tooltip-effect="dark" style="width: 100%" height="350px"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column :label="$t('other.a66')" width="60">
            <template slot-scope="scope">
              <span class="pic">
                <el-image style="width: 50px;" :src="scope.row.imagesUrl" :preview-src-list="[scope.row.imagesUrl]">
                </el-image>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="版面型号" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span> {{ scope.row.layoutModel }}</span>
            </template>
          </el-table-column>
          <el-table-column label="版面名称" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span> {{ scope.row.layoutName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="尺寸" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-select v-model="scope.row.patternSizeId" :placeholder="$t('other.a50')">
                <el-option v-for="item in scope.row.patternSizeList" :key="item.id" :label="item.sizeName"
                  :value="item.id + '-' + item.patternInfoId">
                </el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column label="颜色" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-select v-model="scope.row.patternColourId" :placeholder="$t('other.a50')">
                <el-option v-for="item in scope.row.patternColourList" :key="item.id" :label="item.colourName"
                  :value="item.id + '-' + item.patternInfoId">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>

        <div style="text-align:right">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="getDataList.pageNum" :page-sizes="[15, 20, 30, 50]" :page-size="getDataList.pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="bindTuAn = false">{{ $t('other.a106') }}</el-button>
        <el-button type="primary" @click="createTu">{{ $t('other.a216') }}</el-button>
      </span>
    </el-dialog>
    <!-- 绑定标品图库 -->
    <el-dialog :title="ttpTuStandard" :visible.sync="bindStandard" width="80%">
      <div style="display: flex;">
        <!-- <el-tabs v-model="activeName" :before-leave="beforeLeave">
          <el-tab-pane label="标品图库" name="0"></el-tab-pane>
          <el-tab-pane label="平台图库" name="1"></el-tab-pane>
        </el-tabs> -->
        <el-select style="margin-left: 20px;" v-model="activeName" @change="beforeLeave">
          <el-option :label="$t('other.a3399')" value="0"></el-option>
          <el-option :label="$t('other.a3400')" value="1"></el-option>
        </el-select>
        <el-select style="margin-left: 20px;" v-model="getStandardDataList.groupId" @change="chooseTuStandard()"
          clearable>
          <el-option v-for="item in options" :key="item.id" :label="item.groupsName" :value="item.id">
          </el-option>
        </el-select>
        <div style="margin-left: 20px;">
          <el-input placeholder="版面名称" clearable v-model="layoutName" @input="handleInput"></el-input>
        </div>
      </div>
      <div class="customerPopBox">
        <el-table ref="multipleTableStandard" :data="TuAnItemStandardList" tooltip-effect="dark" style="width: 100%"
          height="350px" @selection-change="handleSelectionChangeStandard">
          <el-table-column type="selection" width="55">
          </el-table-column>
          <el-table-column :label="$t('other.a66')" width="60">
            <template slot-scope="scope">
              <span class="pic">
                <el-image style="width: 50px;" :src="scope.row.layoutImageUrl"
                  :preview-src-list="[scope.row.layoutImageUrl]">
                </el-image>
              </span>
            </template>
          </el-table-column>
          <el-table-column label="版面名称" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span> {{ scope.row.layoutName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="选择SKU" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-select v-model="scope.row.standardPatternPrintImagesId" :placeholder="$t('other.a50')">
                <el-option v-for="item in scope.row.standardPatternPrintImagesList" :key="item.id" :label="item.skuName"
                  :value="item.id + '-TUStandard-' + item.imageUrl">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
        </el-table>

        <div style="text-align:right">
          <el-pagination @size-change="handleSizeChangeStandard" @current-change="handleCurrentChangeStandard"
            :current-page="getStandardDataList.pageNum" :page-sizes="[15, 20, 30, 50]"
            :page-size="getStandardDataList.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="bindStandard = false">{{ $t('other.a106') }}</el-button>
        <el-button type="primary" @click="createTuStandard" v-loading="bindStandardLoading">{{ $t('other.a216') }}</el-button>
      </span>
    </el-dialog>
    <!-- 绑定定制内容 -->
    <el-dialog title="定制内容" :visible.sync="bindTuAnText" width="40%">

      <el-input type="text" v-model="checkTuText.customizedTxt"></el-input>

      <span slot="footer" class="dialog-footer">
        <el-button @click="bindTuAnText = false">{{ $t('other.a106') }}</el-button>
        <el-button type="primary" @click="createTuText">{{ $t('other.a216') }}</el-button>
      </span>
    </el-dialog>
    <!-- <el-dialog title="请选择空包审核的仓库" :visible.sync="diavisableTwo" width="40%">
        <div >
            <el-table :data="errorList" border size="medium" style="width: 100%;">
            <el-table-column prop="date" :label="$t('other.a657')" width="60" >
                <template slot-scope="scope">
                    <span class="pic">
                        <img :src="scope.row.image" />
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="date" :label="$t('other.a677')">
                <template slot-scope="scope">
                    <span>{{scope.row.msg}}</span>
                </template>
            </el-table-column>
            </el-table>	
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="bindError=false">{{$t('other.a5')}}</el-button>
        </span>
    </el-dialog>-->
    <el-dialog :title="$t('other.a676')" :visible.sync="bindError" width="40%">
      <div>
        <el-table :data="errorList" border size="medium" style="width: 100%;">
          <el-table-column prop="date" :label="$t('other.a657')" width="60">
            <template slot-scope="scope">
              <span class="pic">
                <img :src="scope.row.image" />
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="date" :label="$t('other.a677')">
            <template slot-scope="scope">
              <span>{{ scope.row.msg }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="bindError = false">{{ $t('other.a5') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="$t('other.a678')" :visible.sync="massCreateOrderDia" :close-on-click-modal="false" width="30%">
      <div class="modleDownload">
        <a style="color:red;cursor: pointer;" @click="downUrl">{{
          $t('other.a679') }}</a>
      </div>

      <div class="massCreateWrapper">
        <el-upload class="image-uploader" :multiple="false" :auto-upload="true" list-type="text" action
          :before-upload="beforeUpload" :show-file-list="true" :limit="1" :http-request="uploadFile"
          :on-exceed="handleExceed">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">{{ $t('other.a680') }}</div>
        </el-upload>
      </div>
      <div class="masscreateTip" v-show="loadingTip == 1">
        <i class="el-icon-loading"></i>
        {{ $t('other.a681') }}
      </div>
      <div class="masscreateTip" v-show="loadingTip == 2">{{ $t('other.a682') }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="massCreateOrderDia = false">{{ $t('other.a106') }}</el-button>
        <el-button type="primary" @click="massCreateOrderDia = false">{{ $t('other.a274') }}</el-button>
      </span>
    </el-dialog>
    <!-- 审核后的提示弹窗 -->
    <el-dialog :title="$t('other.a685')" :visible.sync="diaLogWindow" :close-on-click-modal="false" width="1200px">
      <div style="text-align:center;font-size:15px;">{{ $t('other.a683') }}:</div>
      <div class="diaOrder">
        <div class="mnjh">
          <div class="plmk">
            <span class="klij">
              <i class="iconfont icon-gouSolid-copy"></i>
              {{ $t('other.a684') }}: ({{ success.length }})
            </span>
          </div>
          <el-table :data="hasSucList" style="width: 100%" height="400px" border>
            <el-table-column prop="orderId" :label="$t('other.a60')"></el-table-column>
            <el-table-column prop="fee" :label="$t('other.a686')"></el-table-column>
          </el-table>
        </div>
        <div class="mnjh">
          <div class="plmk">
            <span class="uyhkg">
              <i class="iconfont icon-gouSolid-copy"></i>
              {{ $t('other.a687') }}: ({{ error.length }})
            </span>
          </div>
          <el-table :data="hasError" style="width: 100%" height="400px" border>
            <el-table-column prop="orderId" :label="$t('other.a60')"></el-table-column>
            <el-table-column prop="msg" :label="$t('other.a688')"></el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer reviveOrder">
        <el-button type="info" @click="diaLogWindow = false">{{ $t('pendingorder.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!-- 审核前弹窗 -->
    <el-dialog :title="$t('other.a685')" :visible.sync="reviewDia" :close-on-click-modal="false" width="1200px">
      <div style="text-align:center;font-size:15px;">{{ $t('other.a683') }}:</div>
      <div class="diaOrder">
        <div class="mnjh">
          <div class="plmk">
            <span class="klij">
              <i class="iconfont icon-gouSolid-copy"></i>
              {{ $t('other.a694') }}: ({{ success.length }})
            </span>
          </div>
          <el-table :data="success" style="width: 100%" height="400px" border>
            <el-table-column prop="orderId" :label="$t('other.a60')"></el-table-column>
            <el-table-column prop="orderId" :label="$t('other.a689')">
              <template slot-scope="scope">
                <span>{{ scope.row.orderIntegrals[0].payIntegral }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="shipByDate" :label="$t('other.a690')"></el-table-column>
          </el-table>
        </div>
        <div class="mnjh">
          <div class="plmk">
            <span class="uyhkg">
              <i class="iconfont icon-gouSolid-copy"></i>
              {{ $t('other.a695') }}: ({{ error.length }})
            </span>
          </div>
          <el-table :data="error" style="width: 100%" height="400px" border>
            <el-table-column prop="orderId" :label="$t('other.a60')"></el-table-column>
            <el-table-column prop="messageToSeller" :label="$t('other.a691')"></el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer reviveOrder">
        <div>
          <el-button type="info" @click="reviewDia = false">{{ $t('pendingorder.cancel') }}</el-button>
          <el-button type="primary" @click="revieworders(0)">{{ $t('pendingorder.uuo') }}</el-button>
        </div>
      </span>
    </el-dialog>

    <!-- 自动审核弹窗 -->
    <el-dialog :title="$t('pendingorder.Turn_on')" :visible.sync="autoAudit" key="itemKey" width="70%">
      <div>
        <el-table :data="autoReviesList" border height="400px" style="width: 100%;">
          <el-table-column :label="$t('pendingorder.Store_Name')" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ showShopNameByshopId(scope.row.shopId) }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('pendingorder.warehouse')" :show-overflow-tooltip="true" width="200">
            <template slot-scope="scope">
              <el-select size="mini" style="width: 120px;" v-model="scope.row.storeId"
                :placeholder="$t('pendingorder.warehouse')">
                <el-option v-for="item in autoReviewWarehouse" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column :label="$t('pendingorder.un_include')" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.isVerify" :active-text="$t('pendingorder.yes')"
                :inactive-text="$t('pendingorder.no')"></el-switch>
            </template>
            <template slot="header">
              <el-tooltip effect="light" :content="$t('other.a656')" placement="top">
                <span>
                  {{ $t('pendingorder.un_include') }}
                  <i class="el-icon-question" style="font-size:22px"></i>
                </span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column :label="$t('pendingorder.auto_distribute')" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span v-if="!scope.row.ruleId && !scope.row.isOpen" style="color:#409EFF;margin:0 5px;cursor: pointer;"
                @click="saveAutoRevies(scope.row)">{{ $t('pendingorder.open') }}</span>
              <span v-if="scope.row.ruleId || scope.row.isOpen" style="color:#409EFF;margin:0 5px;cursor: pointer;"
                @click="saveAutoRevies(scope.row)">{{ $t('pendingorder.Turned_on') }}</span>
              <span v-if="scope.row.ruleId || scope.row.isOpen" style="color:#409EFF;margin:0 5px;cursor: pointer;"
                @click="closeAutoRevies(scope.row)">{{ $t('pendingorder.shut_down') }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="autoAudit = false">{{ $t('other.a5') }}</el-button>
      </span>
    </el-dialog>


    <!-- 同步商品链接 -->
    <el-dialog :title="$t('other.a3372')" :visible.sync="synchronizeProductsShow" key="itemKey" width="30%">
      <div>
        <div class="ipt" style="display: flex;align-items: center;">
          <div class="iptText" style="width: 60px;">店铺：</div>
          <el-select v-model="synchronizeProductsCheck" placeholder="请选择">
            <el-option v-for="item in synchronizeProductsArr" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="ipt" style="display: flex;align-items: center;flex-wrap: wrap;margin-top: 10px;"
          v-if="synchronizeProductsStatus == 2">
          <div class="iptText" style="margin-bottom: 10px;">请输入需要同步平台的SKCID列表：</div>
          <el-input type="textarea" :rows="4" placeholder="请输入需要同步平台的SKCID列表" v-model="synchronizeProductsSKC">
          </el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="synchronizeProductsShow = false">{{ $t('other.a5') }}</el-button>
        <el-button type="primary" @click="synchronizeProducts()">{{ $t('other.a38') }}</el-button>
      </span>
    </el-dialog>

    <!-- 更新图片 -->
    <el-dialog :title="$t('other.a294')" :close-on-click-modal="false" :visible.sync="updatPicShow" width="30%">
      <div style="text-align: center">
        <el-upload class="avatar-uploader" action="https://erp.shopsbu.com/service/access/upload"
          :show-file-list="false" :headers="token" :on-success="(res, file) => handleFileSuccess(ttp, res, file)">
          <img v-if="updatPic.image" :src="updatPic.image" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="imgCancel()">{{ $t('other.a106')
        }}</el-button>
        <el-button type="primary" @click="imgConfirm()">{{ $t('other.a279') }}</el-button>
      </span>
    </el-dialog>

    <div class="okngjkg">
      <el-button size="medium" type="primary" @click="initOrderInfo()">{{ $t('other.a696') }}</el-button>
      <el-button size="medium" type="primary" @click="autoAuditrule()">{{ $t('other.a697') }}</el-button>
      <el-dropdown>
        <el-button style="margin;" size="medium" type="primary">
          {{ $t('other.a698') }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="Synchronize(3)">
            <span>{{ $t('pendingorder.last_3_days') }}</span>
          </el-dropdown-item>
          <el-dropdown-item @click.native="Synchronize(7)">
            <span>{{ $t('pendingorder.last_7_days') }}</span>
          </el-dropdown-item>
          <el-dropdown-item @click.native="Synchronize(30)">
            <span>{{ $t('pendingorder.last_1_month') }}</span>
          </el-dropdown-item>
          <el-dropdown-item @click.native="Synchronize(90)">
            <span>{{ $t('pendingorder.last_3_month') }}</span>
          </el-dropdown-item>
          <el-dropdown-item @click.native="reloadorder = true">
            <span>{{ $t('allorders.Synchronizingorder') }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <!-- <el-button style="margin-left:10px;" type="primary" size="medium" @click="synchronizeProductsOpen">{{
        $t('other.a3372')
      }}</el-button> -->
      <el-dropdown>
        <el-button style="margin-left：10px;" size="medium" type="primary">
          {{
            $t('other.a3372')
          }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="synchronizeProductsOpen(1)">同步单店铺</el-dropdown-item>
          <el-dropdown-item @click.native="synchronizeProductsOpen(2)">同步指定SKC</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-button style="margin-left:10px;" size="medium" type="primary" @click="exportOrderInfo()">{{ $t('other.a699')
      }}</el-button>
      <el-button style="margin-left:10px;" size="medium" type="primary"
        @click="noteOrderDia = true, noteOrderInfo = null">{{ $t('other.a700') }}</el-button>
      <el-dropdown>
        <el-button style="margin-left：10px;" size="medium" type="primary">
          批量生成面单
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="startReadyOrders(4)">TEMU平台面单</el-dropdown-item>
          <el-dropdown-item @click.native="startReadyOrders(3)">工厂线下面单</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown>
        <el-button style="margin-left：10px;" size="medium" type="primary">
          {{ $t('other.a701') }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="createNewOrder(0)">{{ $t('other.a702') }}</el-dropdown-item>
          <el-dropdown-item @click.native="massCreateOrderDia = true">{{ $t('other.a703') }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <div class="colng" @click="showAppDia = true" v-if="!isShopsooo">
        <i class="iconfont icon-shoujiduan tubiao"></i>
        <span>{{ $t('other.a704') }}</span>
        <el-tooltip class="item" effect="dark" :content="$t('other.a705')" placement="top-start">
          <i class="el-icon-question oook"></i>
        </el-tooltip>
      </div>
    </div>

    <div class="midlng">
      <span>
        <el-checkbox @change="targetAll()" v-model="checked">
          <span class="onmbg">{{ !checked ? $t('other.a378') : $t('other.a706') }}({{ targetList.length }})</span>
        </el-checkbox>
      </span>
      <span class="onmbg">{{ amount }}{{ $t('other.a707') }}</span>
    </div>

    <div class="orderArea">
      <div class="order-list-item" v-for="(item, index) in originArr" :key="index">
        <div class="list-desc">
          <span>
            <el-checkbox v-model="item.checked"
              :disabled="item.bulkOrder && !item.bulkOrder.finalpay && item.bulkOrder.payType == 2"
              @change="targetOrder(item)"></el-checkbox>
          </span>

          <el-tooltip v-if="item.amend" effect="light" :content="$t('allorders.modified')" placement="bottom">
            <i class="iconfont icon-sign"></i>
          </el-tooltip>

          <el-tooltip v-if="item.storeFlagId" effect="light" :content="item.storeFlagDes" placement="bottom">
            <i class="iconfont icon-tuihuo2"></i>
          </el-tooltip>

          <span class="seller">{{ $t('pendingorder.orderSn') }}：{{ item.orderId }}</span>
          <span class="seller seller-item">
            {{ $t('pendingorder.status') }}：
            <span class="seller-ppc" style="color:red">{{ orderStatus(item) }}</span>
          </span>
          <span class="seller seller-item">
            {{ $t('homeTwo.Orderactuallypaid') }}({{ getCurence(item.country) }})：
            <span class="seller-ppc">{{ item.escrowAmount }}/(￥:{{ item.rmbPaid }})</span>
          </span>
          <!-- <span v-if="item.distributeStatus > 0 || item.platform == 'TIKTOK' || item.platform == 'TEMU'" class="seller seller-item" -->
          <span v-if="item.escrowAmount" class="seller seller-item"
            style="color:red;">
            {{ $t('other.a708') }}(￥)
            <el-tooltip effect="light" :content="$t('other.a692')" placement="bottom">
              <i class="el-icon-question"></i>
            </el-tooltip>
            <span class="seller-ppc">：{{ item.grossProfit.toFixed(2) }}</span>
          </span>
          <span class="seller seller-item" v-if="!item.cod">{{ $t('lazada.time') }}：{{
            item.createTime }}</span>
          <span class="seller seller-item" v-if="item.cod">
            {{ $t('unprocessedorder.paytime') }}：
            <i style="color:red">{{ $t('allorders.payondelivery') }}</i>
          </span>
          <span v-if="item.distributeStatus = 0" class="seller seller-item">
            {{ $t('pendingorder.delivery_time') }}：
            <span class="seller-ppc" style="color:red">{{ countTime(item) }}</span>
          </span>
          <span v-show="item.platform !== 'LAZADA'" class="seller seller-item">
            {{ $t('pendingorder.cancelTime') }}：
            <span class="seller-ppc" style="color:red">{{ cancelBySystem(item.shipByDate) }}</span>
          </span>
        </div>
        <div class="return-desc">
          <div :class="{ 'return-item': true }">
            <div class="pping return-wrpaer">
              <div class="return-item-list" :class="{ 'unfold': active !== index }" v-for="(ttp, index01) in item.items"
                :key="index01">
                <span class="pic-box">
                  <!-- <img v-image-preview :src="ttp.attributeImage ? ttp.attributeImage : ttp.image" /> -->
                  <img :src="ttp.attributeImage ? ttp.attributeImage : ttp.image" @click="openImg(item, ttp)" />
                </span>
                <div class="pic-box-desc">
                  <div class="desck" v-if="item.platform =='TIKTOK'">{{ ttp.variationSku }} / Label size: {{ ttp.variationName }} | {{ ttp.itemName }}</div>
                  <div class="desck" v-else>{{ ttp.itemName }}</div>

                  <div class="jinmg" v-if="ttp.storeItem">
                    <div class="pic-box-desc-amount">{{ $t('other.a566') }}：{{ ttp.storeItem.storeName }}</div>
                    <div class="pic-box-desc-amount">cusCode：{{ ttp.storeItem.cusCode }}（{{ ttp.storeItem.component ?
                      $t('allorders.item') : $t('allorders.setmeal') }}）</div>
                    <div class="pic-box-desc-amount" v-if="ttp.storeItem.children !== null && !ttp.storeItem.component">
                      <div style="color:red" v-for="(childre, indexTBB) in ttp.storeItem.children" :key="indexTBB">
                        {{ $t('allorders.theitem') }}({{ childre.cusCode }})：{{ childre.skuName }}
                        {{ $t('allorders.quantity') }}：{{ childre.rate * ttp.variationQuantityPurchased }}</div>
                    </div>
                    <div v-if="ttp.storeItem.children == null">
                      <div class="pic-box-desc-amount" style="color:red">sku：{{ ttp.storeItem.skuName }}
                        {{ $t('allorders.quantity') }}：{{ ttp.variationQuantityPurchased }}</div>
                      <div class="pic-box-desc-amount">skuName：{{ ttp.variationName }}</div>
                    </div>
                    <div v-if="ttp.storeItem.additions">
                      <div class="storeItemWrpper" v-for="(gift, giftIndex) in ttp.storeItem.additions"
                        :key="giftIndex">
                        {{ $t('other.a497') }}：{{ gift.skuName }}（{{ gift.cusCode }}） {{ $t('other.a567') }}：{{
                          gift.rate
                          *
                          ttp.variationQuantityPurchased }}</div>
                    </div>
                  </div>
                  <div class="jinmg" v-else>
                    <div class="pic-box-desc-amount">
                      <span class="pic-box-desc-amount-item">sku： {{ ttp.storeItem ? ttp.storeItem.skuName :
                        ttp.variationSku ? ttp.variationSku : ttp.variationName }}</span>
                    </div>
                    <div class="pic-box-desc-amount">
                      <span class="pic-box-desc-amount-item">{{ $t('homeTwo.Specificationname') }}： {{ ttp.storeItem ?
                        ttp.storeItem.variationName ? ttp.storeItem.variationName : description : description }}</span>
                    </div>
                    <div class="pic-box-desc-amount">
                      <span>{{ $t('allorders.quantity') }}: x{{ ttp.variationQuantityPurchased }}</span>
                      <span style="margin-left:20px">{{ $t('homeTwo.Sellingprice') }}: {{ ttp.price ? ttp.price :
                        description }}</span>
                    </div>
                  </div>

                  <div class="storeItemWrpper pic-box-desc-amount">
                    <span>{{ $t('pendingorder.Inventory') }}:</span>
                    <span v-if="ttp.storeItem">
                      {{ $t('pendingorder.In_warehouse') }}:
                      {{ ttp.storeItem ? ttp.storeItem.storeNum : '' }},{{ $t('pendingorder.committed') }}:{{
                        ttp.storeItem ?
                          ttp.storeItem.unShipped : '' }},{{ $t('pendingorder.on_line') }}:{{ ttp.storeItem ?
                        ttp.storeItem.stock
                        : '' }}
                    </span>
                    <!-- <span style="color:red" v-if="ttp.storeItem &&ttp.storeItem.stock <= 0">（库存不足）</span> -->
                    <span style="color:red" v-if="!ttp.storeItem && ttp.itemKey !== 'DXS|EMPTY_ORDER'">{{
                      $t('allorders.Unboundproduct') }}</span>
                    <span class="bind" v-if="ttp.storeItem && item.platform !== 'DXS'"
                      @click="bindProduct(item, ttp)">{{
                        $t('allorders.relationship') }}</span>
                    <span class="bind" v-if="!ttp.storeItem && ttp.itemKey !== 'DXS|EMPTY_ORDER'"
                      @click="bindProduct(item, ttp)">{{ $t('allorders.Tobind') }}</span>
                    <span style="color:red" v-if="ttp.itemKey == 'DXS|EMPTY_ORDER'">{{ $t('allorders.emptyproducts')
                    }}</span>
                  </div>


                  <div class="storeItemWrpper pic-box-desc-amount">
                    <span>定制图案:</span>
                    <span v-if="!ttp.patternInfo" style="color: red;">
                      未关联
                    </span>
                    <span v-if="ttp.patternInfo" style="color: red;">
                      {{ ttp.patternInfo.layoutModel }}
                      {{ ttp.patternInfo.size }}
                      {{ ttp.patternInfo.coluer }}
                    </span>
                    <span class="bind" @click="bindTuProduct(item, ttp)">{{ !ttp.patternInfo ? '去关联' : '变更' }}</span>
                    <span style="margin-left: 20px;">定制内容: <span style="color: red;">{{ ttp.customizedTxt }}</span>
                    </span>
                    <span class="bind" @click="bindTuProductText(item, ttp)">{{ !ttp.customizedTxt ? '去添加' : '变更内容'
                    }}</span>
                  </div>
                  <div class="storeItemWrpper pic-box-desc-amount">
                    <span>图库:</span>
                    <span v-if="!ttp.standardPattern" style="color: red;">
                      未关联
                    </span>
                    <span v-if="ttp.standardPattern" style="color: red;">
                      {{ ttp.standardPattern.layoutName }}
                      {{ ttp.standardPattern.standardPatternPrintImagesList[0].skuName }}
                    </span>
                    <span class="bind" @click="bindStandardTuProduct(item, ttp)">{{ !ttp.standardPattern ? '去关联' : '变更'
                    }}</span>
                  </div>

                  <div class="pic-box-desc-amount"
                    v-if="ttp.storeItem && ttp.storeItem.putAway && !ttp.storeItem.component">
                    <span style="font-size:14px;font-weight:bold;color:#409EFF">
                      {{ $t('other.a709') }}
                      <el-tooltip effect="light" :content="$t('other.a693')" placement="bottom">
                        <i class="el-icon-question"></i>
                      </el-tooltip>
                      ：￥ {{ getVipPirice(ttp) }}
                      <!-- {{ ttp.storeItem.children ? ttp.storeItem.children[0].price * ttp.variationQuantityPurchased :
                        '--' }} -->
                    </span>
                  </div>
                  <div class="pic-box-desc-amount"
                    v-if="ttp.storeItem && ttp.storeItem.putAway && !ttp.storeItem.component">
                    <span class="oriderPutAway">{{ $t('other.a710') }}</span>
                    <span style="margin-left:20px">{{ $t('other.a711') }}：{{ ttp.storeItem.children ?
                      ttp.storeItem.children[0].userId : '--' }}</span>
                  </div>
                </div>
                <div style="margin-left: 10px;text-align: center;">
                  <div class="avatar-uploader" style="cursor: pointer;" v-if="item.platform =='DXS'&&ttp.variationQuantityPurchased>1" @click="stopUpload">
                    <img v-if="ttp.pintImage && ttp.pintImage != ''" :src="ttp.pintImage" class="avatar">
                    <img v-if="ttp.standardPattern"
                      :src="ttp.standardPattern.standardPatternPrintImagesList[0].imageUrl" alt="">
                    <i v-if="!ttp.pintImage && !ttp.standardPattern" class="el-icon-plus avatar-uploader-icon"></i>
                    <i v-if="ttp.pintImage && ttp.pintImage != ''" class="el-icon-plus el-icon-error"
                      @click.stop="updataImg(ttp)"></i>
                  </div>
                  <el-upload v-else class="avatar-uploader" :headers="token"
                    action="https://erp.shopsbu.com/service/access/upload" :show-file-list="false"
                    :on-success="(res, file) => handleAvatarSuccess(ttp, res, file)" :before-upload="beforeAvatarUploadDPI">
                    <img v-if="ttp.pintImage && ttp.pintImage != ''" :src="ttp.pintImage" class="avatar">
                    <img v-if="ttp.standardPattern"
                      :src="ttp.standardPattern.standardPatternPrintImagesList[0].imageUrl" alt="">
                    <i v-if="!ttp.pintImage && !ttp.standardPattern" class="el-icon-plus avatar-uploader-icon"></i>
                    <i v-if="ttp.pintImage && ttp.pintImage != ''" class="el-icon-plus el-icon-error"
                      @click.stop="updataImg(ttp)"></i>
                  </el-upload>
                  <div>子订单打印图</div>
                </div>
              </div>
            </div>
            <div class="pping retrun-reasonr">
              <div class="return-reasonr-desc">{{ $t('pendingorder.shopName') }}：{{ item.shopName }}</div>
              <div class="return-reasonr-desc">
                {{ $t('allorders.Platform') }}：
                <span>{{ item.platform }}</span>
              </div>
              <div class="return-reasonr-desc">
                {{ $t('homeTwo.Buyermessage') }}：
                <span>{{ item.messageToSeller ? item.messageToSeller : description }}</span>
              </div>
              <div class="return-reasonr-desc">
                {{ $t('homeTwo.Sellernotes') }}：
                <span>{{ item.msgToStore ? item.msgToStore : description }}</span>
              </div>
              <div class="return-reasonr-desc" style="color:#409EFF" v-if="item.storeFlagDes">
                {{ $t('other.a712') }}：{{ item.storeFlagDes }}</div>
            </div>
            <div class="pping retrun-reasonr">
              <div class="return-reasonr-desc">{{ $t('pendingorder.methods') }}：{{ item.logistics }}</div>
              <!-- <div class="return-reasonr-desc">{{$t('pendingorder.actually_paid')}}：<span>({{item.currency}}){{item.totalAmount}}</span></div> -->
              <div class="return-reasonr-desc">
                {{ $t('pendingorder.waybill_number') }}：
                <span>{{ item.trackingNo }}</span>
              </div>
              <div class="return-reasonr-desc">{{ $t('pendingorder.recipient') }}：{{ item.address.name }}</div>
              <div class="return-reasonr-desc">{{ $t('pendingorder.phone') }}：{{ item.address.phone }}</div>
            </div>
            <div style="margin-left:20px;padding:0px 20px;" v-if="item.procure && item.bulkOrder">
              <div
                style="padding:2px 10px;background-color: #e59926;color: #fff;border-radius:15px;font-size: 14px; width: 60px;text-align: center;">
                {{ $t('other.a3285') }}</div>
              <div><span>{{ $t('other.a1273') }}：{{ getType(item.bulkOrder.payType) }}</span>
                <span style="margin-left: 10px;" v-if="item.bulkOrder.payType != 1">{{ $t('other.a3288') }}{{
                  item.bulkOrder.preFee }}</span>
                <span style="margin-left: 10px;" v-if="item.bulkOrder.payType != 1">{{ $t('other.a3289') }}{{
                  item.bulkOrder.finalFee }}</span>
              </div>
              <div v-if="item.bulkOrder.payType != 1">
                {{ $t('other.a3290') }}{{ item.bulkOrder.finalpay ? $t('other.a1512') : $t('other.a118') }}
                <el-button class="btnBox" size="mini" type="primary" v-if="!item.bulkOrder.finalpay"
                  @click="remind(item)">{{ $t('other.a3291') }}</el-button>
              </div>
            </div>
            <div class="pping retrun-reasonr-btn">
              <div>
                <el-button class="btnBox" size="mini" type="primary" @click="changeOrderInfo(item)">{{ $t('other.a713')
                }}</el-button>
              </div>
              <div>
                <el-button class="btnBox" size="mini" :type="!item.emptyOrder ? 'primary' : 'danger'"
                  @click="updateEmptyBag(item)">{{ !item.emptyOrder ? $t('homeTwo.Setupanemptypackage') :
                    $t('allorders.Restoreorder') }}</el-button>
              </div>
              <div>
                <el-button class="btnBox" size="mini" type="primary"
                  @click="noteOrderDia = true, noteOrderInfo = item">{{
                    $t('other.a714') }}</el-button>
              </div>
              <div>
                <el-button class="btnBox" @click="showAndhidden(item)" size="mini"
                  :type="!item.hidden ? 'info' : 'danger'">{{ item.hidden ? $t('allorders.Accordingorder') :
                    $t('allorders.Hiddenorder') }}</el-button>
              </div>
              <div v-if="item.platform == 'DXS' || item.platform == 'EXCEL'">
                <el-button class="btnBox" @click="deleteOrderInfo(item)" size="mini" type="info">{{ $t('other.a715')
                }}</el-button>
              </div>

              <!-- <div><el-button style="min-width:150px;margin:3px 0" size="mini" type="primary" @click="changeOrderInfo(item)">{{$t('homeTwo.Modifyorderinformation')}}</el-button></div>
								<div>
									<el-button v-show="item.platform == 'DXS'" size="mini" style="min-width:150px;margin:3px 0" type="primary" @click="deleteOrderInfo(item)">{{$t('allorders.Deleteorder')}}</el-button>
									<el-button v-show="item.platform !== 'DXS'" style="min-width:150px;margin:3px 0" size="mini" type="primary" @click="showAndhidden(item)">{{item.hidden ? $t('allorders.Accordingorder') : $t('allorders.Hiddenorder')}}</el-button>
								</div>
								<div><el-button style="min-width:150px;margin:3px 0" size="mini" type="primary" @click="updateEmptyBag(item)">{{!item.emptyOrder ? $t('homeTwo.Setupanemptypackage') : $t('allorders.Restoreorder')}}</el-button></div>
              <div ></div>-->
            </div>
          </div>
          <!-- <div v-if="item.items.length >3 " style="text-align: center;border-top: 1px solid #eee;padding-top: 10px;" @click="ttp01(index)">
						<span style="margin-left: 15px; color: red;cursor: pointer;" v-if="active !== index"><span class="iconfont icon-xia-down"></span>{{$t('allorders.Morehere')}}</span>
						<span style="margin-left: 15px; color: red;cursor: pointer;" v-else><span class="iconfont icon-xiala1"></span>{{$t('allorders.Hideup')}}</span>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import galleryApi from '@/api/moudles/gallery'
import api from "@/api/api";
import orderApi from "@/api/moudles/order.js";
import newOrders from "@/api/moudles/newOrders";
import CustomerOrder from "../components/dialog";
import Dialog from "../../../../components/dialog/dialog.vue";
import { parse } from "path";
import { mapState, mapActions, mapMutations } from "vuex";
import utils from "../../../../utils/utils";
import newOrdersApi from '@/api/moudles/newOrders'
export default {
  data() {
    return {
      checked: false,
      originArr: [],
      targetList: [],
      orderIdList: [],
      active: "",
      hasSucList: [],
      hasError: [],
      loadingTip: 0,
      reviewDia: false,
      diaLogWindow: false,
      reloadorder: false,
      showAppDia: false,
      userId: null,
      reportOrder: [],
      success: [],
      error: [],
      massCreateOrderDia: false,
      bindOrder: false,
      textDesc: null,
      bindParams: {},
      errorList: [],
      bindError: false,
      noteOrderDia: false,
      autoAudit: false,
      itemKey: 0,
      autoReviesList: [],
      autoReviewWarehouse: [],
      isShopsooo: JSON.parse(localStorage.getItem("isShopsooo")),
      description: this.$t("allorders.description"),
      noteOrderInfo: {},
      msgToStore: null,
      TuAnItemList: [],
      bindTuAn: false,
      bindTuAnText: false,
      checkTuText: {},
      getDataList: {
        pageSize: 20,
        pageNum: 1,
        layoutType: 0,
        galleryType: 0
      },
      getStandardDataList: {
        pageSize: 20,
        pageNum: 1,
        groupId: '',
      },
      total: 0,
      checkTu: null,
      TuitemKey: null,
      ttpTu: null,
      isNotify: false,
      itemTargetList: [],
      successTotal: 0,
      ttpTuStandard: '图库',
      activeName: '0',
      layoutName: '',
      timer: null,
      tabObj: {},
      bindStandard: false,
      bindStandardLoading:false,
      options: [],
      TuAnItemStandardList: [],
      checkTuStandard: null,
      TuStandarditemKey: null,
      TuStandardShopId: null,
      TuStandard: null,

      token: {
        token: JSON.parse(localStorage.getItem('userInfo')).token
      },
      imageUrl: '',
      synchronizeProductsStatus: 1,
      synchronizeProductsShow: false,
      synchronizeProductsArr: [],
      synchronizeProductsCheck: '',
      synchronizeProductsSKC: '',
      updatPic: {
        orderId: '',
        orderSn: '',
        itemKey: '',
        image: '',
      },
      updatPicShow: false,
    };
  },
  components: {
    CustomerOrder,
    Dialog
  },
  props: {
    orderList: {
      type: Array,
      default: []
    },

    activeShopId: {
      type: Number,
      default: 0
    },

    amount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapState({
      isSuper: (state) => state.shopaccess.userInfo.isSuper,
      distributorLevel: (state) => state.shopaccess.userInfo.distributorLevel,
    }),
  },
  watch: {
    orderList() {
      this.originArr = this.orderList;
    },
    amount() {
      this.checked = false;
      this.cancelTargetAll();
    },

    noteOrderDia() {
      if (!this.noteOrderDia) {
        this.msgToStore = null;
      }
    },
    activeName() {
      // this.getStandardDataList= {
      //   pageSize: 20,
      //   pageNum: 1,
      //   groupId: '',
      // }
      // this.bindStandardTuProduct(this.tabObj.item, this.tabObj.ttp)
    },
  },
  created() {
    this.autoReviewWarehouse = utils.getStore();
    this.userId = JSON.parse(localStorage.getItem("userInfo")).userId;
    this.getSelData()
  },
  methods: {
    ...mapMutations("common", [
      "storageOrderInfo",
      "storageOrderInfoCopy",
      "markScrollLocation"
    ]),

    ...mapActions("order", [
      "getAutoreviewrules",
      "addAutoreviewrules",
      "delAutoreviewrules"
    ]),

    ...mapActions('mygoods', [
      'tongBuShopee',
    ]),
    downUrl() {
      let url = '/自建订单导入模板.xlsx'; // public 目录下的文件的 URL
      let link = document.createElement('a'); // 创建一个 <a> 元素
      link.href = url; // 设置链接的 href 属性为文件的 URL
      link.download = '自建订单导入模板.xlsx'; // 设置下载的文件名
      link.style.display = 'none'; // 隐藏链接
      document.body.appendChild(link); // 将链接添加到文档中
      link.click(); // 模拟点击链接以触发下载
      document.body.removeChild(link); // 下载完成后移除链接
    },

    getVipPirice(ttp) {
      let price = null
      if (this.isSuper) {
        price = ttp.storeItem.children ? ttp.storeItem.children[0].price * ttp.variationQuantityPurchased :
          '--'
      } else {
        if (this.distributorLevel == 0) {
          price = ttp.storeItem.children ? (ttp.storeItem.children[0].vipPrice ? ttp.storeItem.children[0].vipPrice : ttp.storeItem.children[0].price) * ttp.variationQuantityPurchased :
            '--'
        } else if (this.distributorLevel == 1) {
          price = ttp.storeItem.children ? (ttp.storeItem.children[0].superVipPrice ? ttp.storeItem.children[0].superVipPrice : ttp.storeItem.children[0].price) * ttp.variationQuantityPurchased :
            '--'
        }
      }
      return price
    },
    chooseTu() {
      this.getDataList.pageNum = 1
      this.bindTuProduct()
    },

    bindTuProductText(item, ttp) {
      console.log(item)
      console.log(ttp)
      this.checkTuText = {
        orderId: ttp.orderId,
        orderSn: ttp.orderSn,
        itemKey: ttp.itemKey,
        customizedTxt: ttp.customizedTxt,
      }
      this.bindTuAnText = true
    },
    //定制内容
    createTuText() {
      if (!this.checkTuText.customizedTxt) {
        this.$message.warning('请输入定制内容')
        return
      }
      var formData = new FormData()
      formData.append('orderId', this.checkTuText.orderId)
      formData.append('orderSn', this.checkTuText.orderSn)
      formData.append('itemKey', this.checkTuText.itemKey)
      formData.append('customizedTxt', this.checkTuText.customizedTxt)
      galleryApi.updateCustomizedTxt(formData)
        .then(res => {
          if (res.code === 200) {
            console.log('数据1', res.data)
            this.bindTuAnText = false
            this.$message.success(res.msg)
            this.initOrderData();
          } else {
            this.$message.warning(res.msg)
          }
        })
    },
    //变更图案绑定
    createTu() {
      console.log("===111")
      console.log(this.checkTu)
      if (this.checkTu) {
        console.log(this.checkTu)
        if (!this.checkTu.patternSizeId) {
          this.$message.warning('请选择尺寸')
          return
        }
        if (!this.checkTu.patternColourId) {
          this.$message.warning('请选择颜色')
          return
        }
        let data = {
          patternInfoId: this.checkTu.patternColourId.split('-')[1],
          patternColourId: this.checkTu.patternColourId.split('-')[0],
          patternSizeId: this.checkTu.patternSizeId.split('-')[0],
          itemKey: this.TuitemKey
        }
        console.log(data)
        galleryApi.bindPatter(data)
          .then(res => {
            if (res.code === 200) {
              console.log('数据1', res.data)
              this.bindTuAn = false
              this.$message.success(res.msg)
              this.initOrderData();
            } else {
              this.$message.warning(res.msg)
            }
          })
      }

    },

    bindTuProduct(item, ttp) {
      console.log(item)
      if (ttp) {
        this.TuitemKey = ttp.itemKey
        if (ttp.patternInfo) {
          this.ttpTu = '定制图库：' + (ttp.patternInfo.layoutModel) + '-' + ttp.patternInfo.size + '-' + ttp.patternInfo.coluer
        } else {
          this.ttpTu = '定制图库'
        }
      }
      var formData = new FormData()
      formData.append('pageNum', this.getDataList.pageNum)
      formData.append('pageSize', this.getDataList.pageSize)
      formData.append('layoutType', this.getDataList.layoutType)
      formData.append('galleryType', this.getDataList.galleryType)
      formData.append('userId', this.userId)
      galleryApi.getPatternBadPage(formData)
        .then(res => {
          if (res.code === 200) {
            console.log('数据1', res.data)
            this.bindTuAn = true
            for (let i = 0; i < res.data.records.length; i++) {
              res.data.records[i].patternSizeId = null;
              res.data.records[i].patternColourId = null;
            }
            this.TuAnItemList = res.data.records
            this.total = res.data.total
          } else {
            this.$message.warning(res.msg)
          }
        })
    },
    handleSelectionChange(val) {
      if (val.length > 1) {
        this.$refs.multipleTable.clearSelection();
        this.$refs.multipleTable.toggleRowSelection(
          val[val.length - 1]
        )
      }
      this.checkTu = val[val.length - 1];
    },
    //控制每页显示订单条数
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.getDataList.pageNum = 1
      this.getDataList.pageSize = parseInt(`${val}`)
      this.bindTuProduct()
    },
    //显示当前第几页
    handleCurrentChange(val) {
      console.log(val)
      this.getDataList.pageNum = parseInt(`${val}`)
      this.bindTuProduct()

    },
    openImg(item, ttp) {
      console.log(item)
      console.log(ttp)
      this.updatPic.orderId = item.orderId;
      this.updatPic.orderSn = ttp.orderSn;
      this.updatPic.itemKey = ttp.itemKey;
      this.updatPic.image = ttp.attributeImage ? ttp.attributeImage : ttp.image;
      this.updatPicShow = true;
    },
    handleFileSuccess(item, res, file) {
      console.log(item)
      console.log(file)
      // console.log(file.response.data)
      this.updatPic.image = file.response.data;
    },

    imgCancel() {
      this.updatPic = {
        orderId: '',
        orderSn: '',
        itemKey: '',
        image: '',
      }
      this.updatPicShow = false;
    },
    imgConfirm() {
      var formData = new FormData()
      formData.append('orderId', this.updatPic.orderId)
      formData.append('itemKey', this.updatPic.itemKey)
      formData.append('orderSn', this.updatPic.orderSn)
      formData.append('image', this.updatPic.image)
      galleryApi.updateOrderItemImage(formData)
        .then(res => {
          if (res.code === 200) {
            console.log('数据1', res.data)
            this.$message.success(res.msg)
            this.initOrderData();
            this.updatPicShow = false;
          } else {
            this.$message.warning(res.msg)
          }
        })
    },

    updataImg(item) {
      this.$confirm('是否删除打印图?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var formData = new FormData()
        formData.append('orderId', item.orderId)
        formData.append('itemKey', item.itemKey)
        formData.append('orderSn', item.orderSn)
        formData.append('pintImage', '')
        galleryApi.uploadPintImage(formData)
          .then(res => {
            if (res.code === 200) {
              console.log('数据1', res.data)
              this.$message.success(res.msg)
              this.initOrderData();
            } else {
              this.$message.warning(res.msg)
            }
          })
      })
    },
    handleAvatarSuccess(item, res, file) {
      console.log(item)
      console.log(file)
      // return
      // console.log(file.response.data)
      // this.imageUrl = URL.createObjectURL(file.raw);
      // this.ruleForm.imagesUrl = file.response.data
      // console.log(this.ruleForm)

      var formData = new FormData()
      formData.append('orderId', item.orderId)
      formData.append('itemKey', item.itemKey)
      formData.append('orderSn', item.orderSn)
      formData.append('pintImage', file.response.data)
      galleryApi.uploadPintImage(formData)
        .then(res => {
          if (res.code === 200) {
            console.log('数据1', res.data)
            this.$message.success(res.msg)
            this.initOrderData();
          } else {
            this.$message.warning(res.msg)
          }
        })
    },
    stopUpload(){
      // this.$message.warning(this.$t('other.a3426'))
      this.$alert(this.$t('other.a3426'), this.$t('chat.hint'), {
          confirmButtonText: this.$t('chat.confirm'),
          callback: action => {
          }
        });
    },
    beforeAvatarUploadDPI(file) {
      console.log(file, "file");
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      // return new Promise(async (resolve, reject) => {
      //   try {
      //     //       // 原生二进制解析，无第三方依赖
      //     const { dpiX, dpiY } = await this.getImageDpiNative(file);
      //     console.log("原生解析DPI", dpiX, dpiY);
      //     const minDpi = 150;
      //     // 无DPI数据 / 任一轴不足阈值 直接拦截
      //     if (
      //       dpiX === undefined ||
      //       dpiY === undefined ||
      //       dpiX != minDpi ||
      //       dpiY != minDpi
      //     ) {
      //       let textNum = dpiX != minDpi?dpiX:dpiY != minDpi?dpiY:72;
      //       if(dpiX === undefined||dpiY === undefined){
      //           textNum = 72;
      //       }
      //       console.log(textNum)
      //       let text = this.$t('other.a3422')+textNum+this.$t('other.a3423')
      //       this.$alert(text, this.$t('other.a142'), {
      //           confirmButtonText: this.$t('other.a5'),
      //       });
      //       reject(false);
      //       return;
      //     }
      //     resolve(true);
      //   } catch (err) {
      //     console.error("原生解析图片失败", err);
      //     this.$message.warning("读取图片分辨率失败，禁止上传");
      //     reject(false);
      //   }
      // });
    },
    /**
     * 原生解析图片DPI，无第三方库
     * @param {File} file 图片文件
     * @returns {Promise<{dpiX: number|undefined, dpiY: number|undefined}>}
     */
    getImageDpiNative(file) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const buf = new Uint8Array(e.target.result);
          // JPG解析
          if (this.isJpg(buf)) {
            const dpi = this.parseJpgDpi(buf);
            resolve(dpi);
            return;
          }
          // PNG解析
          if (this.isPng(buf)) {
            const dpi = this.parsePngDpi(buf);
            resolve(dpi);
            return;
          }
          // 非jpg/png 无DPI数据
          resolve({ dpiX: undefined, dpiY: undefined });
        };
        reader.readAsArrayBuffer(file);
      });
    },

    // 判断JPG文件
    isJpg(buf) {
      return buf[0] === 0xff && buf[1] === 0xd8 && buf[2] === 0xff;
    },
    // 判断PNG文件
    isPng(buf) {
      return (
        buf[0] === 0x89 && buf[1] === 0x50 && buf[2] === 0x4e && buf[3] === 0x47
      );
    },

    // JPG 解析EXIF DPI
    parseJpgDpi(buf) {
      let offset = 2;
      const len = buf.length;
      while (offset < len - 4) {
        // 找到EXIF标记 0xFFE1
        if (buf[offset] === 0xff && buf[offset + 1] === 0xe1) {
          const segLen = (buf[offset + 2] << 8) | buf[offset + 3];
          const exifStart = offset + 4;
          // 跳过"Exif\0\0"头部 6字节
          const tiffStart = exifStart + 6;
          const byteOrder = buf[tiffStart];
          const isLittle = byteOrder === 0x49; // II小端
          let tagOffset = tiffStart + 2;
          const tagCount = this.read16(buf, tagOffset, isLittle);
          tagOffset += 2;
          // 遍历标签
          for (let i = 0; i < tagCount; i++) {
            const tag = this.read16(buf, tagOffset, isLittle);
            // XResolution=0x011A YResolution=0x011B
            if (tag === 0x011a || tag === 0x011b) {
              const type = this.read16(buf, tagOffset + 2, isLittle);
              const count = this.read32(buf, tagOffset + 4, isLittle);
              const valOff = this.read32(buf, tagOffset + 8, isLittle);
              // 有理数类型，读取分子分母
              if (type === 5) {
                const num = this.read32(buf, exifStart + valOff, isLittle);
                const den = this.read32(buf, exifStart + valOff + 4, isLittle);
                const dpi = Math.round(num / den);
                if (tag === 0x011a) return { dpiX: dpi, dpiY: undefined };
                if (tag === 0x011b) return { dpiX: undefined, dpiY: dpi };
              }
            }
            tagOffset += 12;
          }
          break;
        }
        offset += 2 + ((buf[offset + 2] << 8) | buf[offset + 3]);
      }
      return { dpiX: undefined, dpiY: undefined };
    },

    // PNG 解析pHYs块获取像素每米，换算DPI
    parsePngDpi(buf) {
      let offset = 8; // PNG头部8字节
      const len = buf.length;
      while (offset < len - 12) {
        const chunkLen = this.read32(buf, offset, false);
        const chunkType = String.fromCharCode(
          buf[offset + 4],
          buf[offset + 5],
          buf[offset + 6],
          buf[offset + 7]
        );
        if (chunkType === "pHYs") {
          const pxPerMeterX = this.read32(buf, offset + 8, false);
          const pxPerMeterY = this.read32(buf, offset + 12, false);
          const dpiX = Math.round(pxPerMeterX * 0.0254);
          const dpiY = Math.round(pxPerMeterY * 0.0254);
          return { dpiX, dpiY };
        }
        offset += 4 + 4 + chunkLen + 4;
      }
      return { dpiX: undefined, dpiY: undefined };
    },

    // 读取16位数值
    read16(buf, off, little) {
      return little
        ? (buf[off + 1] << 8) | buf[off]
        : (buf[off] << 8) | buf[off + 1];
    },
    // 读取32位数值
    read32(buf, off, little) {
      return little
        ? (buf[off + 3] << 24) |
            (buf[off + 2] << 16) |
            (buf[off + 1] << 8) |
            buf[off]
        : (buf[off] << 24) |
            (buf[off + 1] << 16) |
            (buf[off + 2] << 8) |
            buf[off + 3];
    },
    handleInput() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        if (this.searchInput !== '') {
          this.getStandardDataList.pageNum = 1
          this.bindStandardTuProduct()
        }
      }, 1000) // 节流间隔 1 秒
    },
    chooseTuStandard() {
      console.log(44444)
      this.getStandardDataList.pageNum = 1
      this.bindStandardTuProduct()
    },
    getSelData() {
      galleryApi
        .getStandardPatternPrintGroupsList(this.userId)
        .then(res => {
          console.log(res)
          console.log("====12121s")
          if (res.code === 200) {
            this.options = res.data
          } else {
            this.$message.warning(res.msg)
          }
        })
    },
    bindStandardTuProduct(item, ttp) {
      console.log(item, 'item')
      if (ttp) {
        this.tabObj = {
          item,
          ttp
        }
        this.TuStandardShopId = item.shopId
        this.TuStandarditemKey = ttp.itemKey
        this.TuStandard = ttp
        if (ttp.standardPattern) {
          this.ttpTuStandard = '图库：' + (ttp.standardPattern.layoutName) + '-' + ttp.standardPattern.standardPatternPrintImagesList[0].skuName
        } else {
          this.ttpTuStandard = '图库'
        }
      }
      var formData = new FormData()
      formData.append('pageNum', this.getStandardDataList.pageNum)
      formData.append('pageSize', this.getStandardDataList.pageSize)
      formData.append('groupId', this.getStandardDataList.groupId)
      formData.append('userId', this.userId)
      formData.append('galleryType', this.activeName)
      formData.append('layoutName', this.layoutName)
      galleryApi.standardPatternPage(formData)
        .then(res => {
          if (res.code === 200) {
            console.log('数据1', res.data)
            this.bindStandard = true
            for (let i = 0; i < res.data.records.length; i++) {
              res.data.records[i].standardPatternPrintImagesId = null;
              res.data.records[i].imagesUrl = null;
            }
            this.TuAnItemStandardList = res.data.records
            this.total = res.data.total
          } else {
            this.$message.warning(res.msg)
          }
        })
    },
    beforeLeave(activeName) {
      if (activeName == 1) {
        // 返回 Promise 以支持阻止切换
        this.$confirm(
          '是否确认关联平台图库，关联后无法撤回！',
          this.$t("other.a142"),
          {
            confirmButtonText: this.$t('other.a145'),
            cancelButtonText: this.$t('other.a146'),
            type: 'warning'
          }
        ).then(() => {
          this.getStandardDataList = {
            pageSize: 20,
            pageNum: 1,
            groupId: '',
          }
          this.bindStandardTuProduct(this.tabObj.item, this.tabObj.ttp)
        }).catch(() => {
          this.activeName = '0'
        })
      }
      // 其他情况允许切换
    },
    createTuStandard() {
      if (this.checkTuStandard) {
        console.log(this.checkTuStandard)
        if (!this.checkTuStandard.standardPatternPrintImagesId) {
          this.$message.warning('请选择')
          return
        }
        var formData = new FormData()
        let standardPatternPrintImagesId = this.checkTuStandard.standardPatternPrintImagesId.split('-TUStandard-')[0]
        formData.append('standardPatternPrintImagesId', standardPatternPrintImagesId)
        formData.append('shopId', this.TuStandardShopId)
        formData.append('itemKey', this.TuStandarditemKey)
        formData.append('orderId', this.tabObj.item.orderId)
        if (this.TuStandard.pintImage) {
          this.$confirm('是否覆盖子订单打印图?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.bindStandardLoading = true;
            galleryApi.orderBindPrintImage(formData)
              .then(res => {
                this.bindStandardLoading = false;
                if (res.code === 200) {
                  console.log('数据1', res.data)
                  this.bindStandard = false
                  this.$message.success(res.msg)
                  let data = {
                    response: {
                      // data: this.checkTuStandard.standardPatternPrintImagesId.split('-TUStandard-')[1]
                      data: ''
                    }
                  }
                  console.log(data)
                  this.handleAvatarSuccess(this.TuStandard, '', data)
                } else {
                  this.$message.warning(res.msg)
                }
              }).catch(err=>{
                this.bindStandardLoading = false;
              })
          })
        } else {
          this.bindStandardLoading = true;
          galleryApi.orderBindPrintImage(formData)
            .then(res => {
                this.bindStandardLoading = false;
              if (res.code === 200) {
                console.log('数据1', res.data)
                this.bindStandard = false
                this.$message.success(res.msg)
                let data = {
                  response: {
                    // data: this.checkTuStandard.standardPatternPrintImagesId.split('-TUStandard-')[1]
                    data: ''
                  }
                }
                console.log(data)
                this.handleAvatarSuccess(this.TuStandard, '', data)
              } else {
                this.$message.warning(res.msg)
              }
            }).catch(err=>{
                this.bindStandardLoading = false;
              })
        }
      } else {
        this.$message.warning('请勾选数据')
      }

    },

    handleSelectionChangeStandard(val) {
      if (val.length > 1) {
        this.$refs.multipleTableStandard.clearSelection();
        this.$refs.multipleTableStandard.toggleRowSelection(
          val[val.length - 1]
        )
      }
      this.checkTuStandard = val[val.length - 1];
    },
    //控制每页显示订单条数
    handleSizeChangeStandard(val) {
      console.log(`每页 ${val} 条`);
      this.getStandardDataList.pageNum = 1
      this.getStandardDataList.pageSize = parseInt(`${val}`)
      this.bindStandardTuProduct()
    },
    //显示当前第几页
    handleCurrentChangeStandard(val) {
      console.log(val)
      this.getStandardDataList.pageNum = parseInt(`${val}`)
      this.bindStandardTuProduct()

    },
    remind(item) {
      newOrders
        .sendMsgRemind({
          orderId: item.orderId,
          userId: this.userId
        })
        .then(res => {
          if (res.code === 200) {
            console.log("desc", res.data);
            this.$message.success(this.$t('other.a3292'));
          } else {
            this.$message.warning(res.msg);
          }
        });
    },
    getType(index) {
      let obj = {
        1: this.$t('other.a3286'),
        2: this.$t('other.a3287'),
      }
      return obj[index]
    },
    massNoteOrder() {
      if (!this.targetList.length) {
        this.$message.warning(this.$t('other.a716'));
        this.noteOrderDia = false;
        return;
      }
      let list = JSON.parse(JSON.stringify(this.targetList));
      let params = list.map(p => {
        return {
          msgToStore: this.msgToStore,
          orderId: p.orderId,
          shopId: p.shopId,
          userId: this.userId
        };
      });

      let list2 = [];
      params.forEach(i => {
        list2.push(this.setOrderNoteToStore(i));
      });

      Promise.all(list2).then(res => {
        console.log("res", res);
        let flag = false;
        res.forEach(i => {
          if (i !== "success") {
            flag = true;
          }
        });
        this.initOrderData();
        this.noteOrderDia = false;
        if (!flag) {
          this.targetList.forEach(p => {
            p.msgToStore = this.msgToStore;
          });
          this.$message.success(this.$t('other.a717'));
        } else {
          this.$message.warning(this.$t('other.a718'));
        }
      });
    },

    setOrderNoteToStore(params) {
      return new Promise((resolve, reject) => {
        newOrders.updateMsgToStore(params).then(res => {
          if (res.code === 200) {
            resolve("success");
          } else {
            reject("fail data");
            this.$message.warning(res.msg);
          }
        });
      });
    },

    confirmNoteOrder() {
      console.log(this.noteOrderInfo);
      if (!this.msgToStore) {
        this.msgToStore = null;
      }

      newOrders
        .updateMsgToStore({
          msgToStore: this.msgToStore,
          orderId: this.noteOrderInfo.orderId,
          shopId: this.noteOrderInfo.shopId,
          userId: this.userId
        })
        .then(res => {
          if (res.code === 200) {
            console.log("desc", res.data);
            this.noteOrderInfo.msgToStore = this.msgToStore;
            this.noteOrderDia = false;
            this.$message.success(this.$t('other.a719'));
          } else {
            this.$message.warning(res.msg);
          }
        });
    },

    //更新订单状态
    initOrderData() {
      this.$emit("updataOrderList");
    },
    revieworders(num) {
      let that = this;
      that.hasSucList = [];
      that.hasError = [];
      if (num == 0) {
        console.log(this.success);
        if (!this.success.length) {
          this.$message.warning(this.$t('other.a720'));
          return;
        }

        let list = this.success.map(p => {
          let obj = this.targetList.find(i => i.orderId == p.orderId);
          p.targetStoreId = obj.storeId;
          return {
            goodsType: -1,
            orderId: p.orderId,
            shopId: p.shopId,
            storeId: obj.targetStoreId,
            service: p.service,
            userId: this.userId,
            platform: p.platform
          };
        });

        that.auditOrders(list).then(res => {
          console.log("res", res);
          const { success, errors } = res;
          if (success.length > 0) {
            that.hasSucList.push(...success);
          }
          if (errors.length > 0) {
            that.hasError.push(...errors);
          }


          this.reviewDia = false;
          this.initOrderData();
          this.cancelTargetAll();
          this.diaLogWindow = true;
          console.log("hasSucList", that.hasSucList);
          console.log("hasError", that.hasError);
        })



        // Promise.all(mosieList).then(res => {
        //   console.log("res", res);
        //   let list = res;
        //   list.forEach(p => {
        //     if (p.success.length > 0) {
        //       that.hasSucList.push(...p.success);
        //     }
        //     if (p.errors.length > 0) {
        //       that.hasError.push(...p.success);
        //     }
        //   });

        //   this.reviewDia = false;
        //   this.initOrderData();
        //   this.cancelTargetAll();
        //   this.diaLogWindow = true;
        //   console.log("hasSucList", that.hasSucList);
        //   console.log("hasError", that.hasError);
        // });
      }
    },

    //审核现货订单
    auditOrders(params) {
      return new Promise((resolve, reject) => {
        orderApi.reviewOrder(params).then(res => {
          if (res.code === 200) {
            resolve(res.data);
            // this.reviewDia=false
            // console.log('success',res.data)
            // this.initOrderData()
            // this.hasSucList=res.data.success
            // this.hasError=res.data.errors
            // this.cancelTargetAll()
            // this.diaLogWindow=true
          } else {
            reject("fail data");
            this.$message.warning(res.msg);
          }
        });
      });
    },

    //关闭 自动审核
    closeAutoRevies(item) {
      orderApi.delAutoreviewrules(item).then(res => {
        if (res.code === 200) {
          console.log("desc", res.data);
          this.$message.success(this.$t('other.a721'));
        } else {
          this.$message.warning(res.msg);
        }
      });
      this.autoReviesList.forEach(p => {
        if (p.shopId === item.shopId) {
          p.isOpen = false;
          p.ruleId = "";
          p.storeId = "";
          p.isVerify = false;
          p.isService = false;
        }
      });
      console.log(this.autoReviesList);
    },
    //开启自动审核
    saveAutoRevies(item) {
      if (!item.storeId) {
        this.$message.error(this.$t('other.a672'));
        return;
      }

      if (this.storeType === 0) {
        this.$message.error(
          this.$t('other.a671')
        );
        return;
      }

      this.autoReviesList.forEach(p => {
        if (p.shopId === item.shopId) {
          p.isOpen = true;
        }
      });
      console.log(item);

      orderApi.addAutoreviewrules(item).then(res => {
        if (res.code === 200) {
          console.log("desc", res.data);
          this.$message.success(this.$t('other.a722'));
          this.autoReviesList.forEach(p => {
            if (p.shopId === item.shopId) {
              p.ruleId = res.data.ruleId;
              p.isOpen = true;
            }
          });
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    //获取自动审核信息
    autoAuditrule() {
      let shopsLlist = utils.getShopeeAndLazadaShopInfo();
      if (shopsLlist) {
        this.autoReviesList = shopsLlist.map(p => {
          return {
            isService: false,
            isService: false,
            isVerify: false,
            ruleId: null,
            shopId: p.value,
            storeId: null,
            userId: this.userId
          };
        });
      }
      console.log("shopsLlist", shopsLlist);
      orderApi
        .getAutoreviewrules({
          userId: this.userId
        })
        .then(res => {
          if (res.code === 200) {
            console.log("desc", res.data);
            let list = [];
            this.autoReviesList.forEach(k => {
              let ttp = res.data.find(item => item.shopId == k.shopId);
              console.log("ttp", ttp);
              list.push(ttp ? ttp : k);
            });

            console.log(list);
            console.log("autoReviesList", this.autoReviesList);
            this.autoReviesList = list;
            this.itemKey++;
            this.autoAudit = true;
          } else {
            this.$message.warning(res.msg);
          }
        });
    },

    //审核订单时预审核订单情况
    initOrderInfo() {
      let that = this;
      that.success = [];
      that.error = [];
      let list = this.targetList;

      if (!list.length) {
        this.$message.warning(this.$t('other.a723'));
        return;
      }

      let unAuditedList = [];
      let list2 = [];
      let flag = false;
      console.log(list)
      list.forEach(p => {
        if ((p.canAudit == 1 || p.canAudit == 2) && !p.emptyOrder) {
          unAuditedList.push(p);
          flag = true;
        } else {
          list2.push(p);
        }
      });

      let restNum = list.length - unAuditedList.length;

      if (flag) {
        let text =
          this.$t('other.a724') +
          list.length +
          this.$t('other.a725') +
          unAuditedList.length +
          this.$t('other.a726') +
          restNum +
          this.$t('other.a727');
        this.$confirm(text, this.$t('other.a142'), {
          confirmButtonText: this.$t('other.a728'),
          cancelButtonText: this.$t('other.a146'),
          type: "warning"
        }).then(() => {
          this.preApprovalorder(list2);
        });
        return;
      }

      console.log("unAuditedList", unAuditedList);
      this.preApprovalorder(list);
    },

    preApprovalorder(list) {
      let that = this;
      let maplist = new Map();
      for (let i = 0; i < list.length; i++) {
        if (list[i].items[0]) {
          if (list[i].items[0].itemKey == "DXS|EMPTY_ORDER") {
            list[i].targetStoreId = list[i].items[0].variationName.split("_")[1];
          } else {
            list[i].targetStoreId = list[i].items[0].storeItem.storeId;
          }
        }
        let arr = maplist.get(list[i].targetStoreId);
        if (arr == null || arr == undefined) {
          arr = [];
        }
        arr.push(list[i].orderId);
        maplist.set(list[i].targetStoreId, arr);
      }

      let params = [];

      maplist.forEach((key, i) => {
        let list = [];
        key.forEach((item, value) => {
          list.push(item);
        });
        params.push({
          storeId: i,
          orderIds: list,
          userId: this.userId
        });
      });
      that.reportOrder = [];

      if (params.length) {
        const loading = this.$loading({
          lock: true,
          text: that.$t('other.a3425'),
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        for (let i = 0; i < params.length; i++) {
          api.auditOrder(params[i]).then(res => {
            if (res.code === 200) {
              console.log(res.data);
              if (res.data.success.length > 0) {
                res.data.success.forEach(p => {
                  p.shipByDate = utils.getCurrnetTime(p.shipByDate);
                  that.success.push(p);
                });
              }
              if (res.data.error.length > 0) {
                res.data.error.forEach(p => {
                  p.shipByDate = utils.getCurrnetTime(p.shipByDate);
                  that.error.push(p);
                });
              }

              that.reportOrder.push(res.data);
              if (that.reportOrder.length == params.length) {
                loading.close();
                console.log("success", that.success);
                console.log("error", that.error);
                that.reviewDia = true;
              }
            } else {
              loading.close();
              that.$message.warning(res.msg);
            }
          }).catch(err=>{
            loading.close();
          });
        }
      }
    },

    targetAll() {
      if (this.checked) {
        this.originArr.forEach(p => {
          p.checked = true;
          this.targetOrder(p);
        });
      } else {
        this.cancelTargetAll();
      }
    },

    //取消全选
    cancelTargetAll() {
      this.orderIdList = [];
      this.targetList = [];
      this.originArr.forEach(p => {
        p.checked = false;
      });
    },

    targetOrder(item) {
      if (item.checked && !this.orderIdList.includes(item.orderId)) {
        this.orderIdList.push(item.orderId);
        this.targetList.push(item);
      }

      if (!item.checked && this.orderIdList.includes(item.orderId)) {
        let num = this.indexValue(this.orderIdList, item.orderId);
        console.log("num", num);
        if (num !== -1) {
          this.orderIdList.splice(num, 1);
          this.targetList.splice(num, 1);
        }
      }
      // console.log('orderIdList',this.orderIdList)
      console.log("targetList", this.targetList);
    },
    warningTips(text) {
      this.$confirm(text, this.$t('other.a142'), {
        confirmButtonText: this.$t('other.a729'),
        cancelButtonText: this.$t('other.a146'),
        type: "warning"
      })
        .then(() => { })
        .catch(() => { });
    },

    deleteOrderInfo(item) {
      console.log(item);

      this.$confirm(this.$t('other.a608'), this.$t('other.a142'), {
        confirmButtonText: this.$t('other.a235'),
        cancelButtonText: this.$t('other.a146'),
        type: "warning"
      }).then(() => {
        item.createTime = null;
        item.shipByDate = null;
        newOrders.delDxsStoreItem(item).then(res => {
          if (res.code === 200) {
            console.log("desc", res.data);
            this.$message.success(this.$t('other.a565'));
            this.initOrderData();
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },

    orderStatus(item) {
      let text = null;
      if (item.payTime && item.orderStatus == "READY_TO_SHIP") {
        text = this.$t('other.a730');
      } else if (item.cod) {
        text = this.$t('other.a731');
      } else if (item.orderStatus == "UNPAID") {
        text = this.$t('other.a147');
      } else {
        text = item.orderStatus;
      }

      return text;
    },

    bindVirualSku(val) {
      console.log(val);
      console.log(this.bindParams);

      api
        .setVirtualSku({
          itemKey: this.bindParams.itemKey,
          shopId: this.bindParams.shopId,
          userId: this.bindParams.userId,
          storeId: val
        })
        .then(res => {
          if (res.code === 200) {
            if (res.data.success) {
              this.$message.success(this.$t('other.a732'))
            } else {
              this.$message.warning(res.data.msg)
            }
            console.log('desc', res.data)
          } else {
            this.$message.warning(res.msg)
          }
        })

    },

    updataItem(data) {
      console.log("data", data);
      this.bindParams.cusCode = Number(data[0].itemKey.split("|")[1]);
      console.log(this.bindParams);
      newOrders.bindByItemKey([this.bindParams]).then(res => {
        if (res.code === 200) {
          console.log("desc", res.data);
          if (res.data.error.length > 0) {
            // this.errorList = res.data.error;
            // this.bindError = true;
            this.tongBuShopee({
              shopId: sessionStorage.getItem('targetShopId'),
              userId: this.userId
            }).then(res => {
              if (res.code === 200) {
                this.$message({
                  message: '首次绑定需要正在从平台同步信息，需稍后1分钟 再重试！谢谢',
                  type: 'warning',
                  duration: 10000
                });
                setTimeout(() => {
                  this.hideLoading()
                  this.$message.success(this.$t('other.a2405'))
                }, 10000)
              } else {
                this.$message.warning(res.msg)
              }
            })
          }
          if (res.data.error.length == 0) {
            this.$message.success(this.$t('other.a733'));
            this.initOrderData();
          }

          this.bindOrder = false;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },

    bindProduct(outerItem, item) {
      if (item.storeItem) {
        let storeName = item.storeItem.storeName;
        let itemSku = item.storeItem.itemSku;
        let skuName = item.storeItem.skuName;
        this.textDesc =
          this.$t('other.a734') +
          storeName +
          "/" +
          this.$t('other.a735') + ":" +
          itemSku +
          "/" + this.$t('other.a736') + ":" +
          skuName;
      } else {
        this.textDesc = this.$t('other.a737');
      }

      console.log(this.textDesc);
      console.log(item);
      (this.bindParams.itemKey = item.itemKey),
        (this.bindParams.shopId = outerItem.shopId),
        (this.bindParams.userId = this.userId);
      this.bindOrder = true;
      console.log(this.bindParams);
    },

    updateEmptyBag(item) {
      console.log(item);
      if (!item.emptyOrder) {
        let flag = false;
        item.items.forEach(p => {
          if (!p.storeItem) {
            flag = true;
          }
        });
        if (flag) {
          this.$message.warning(this.$t('other.a738'));
          return;
        }
      }
      let test = null;
      if (item.emptyOrder) {
        test = this.$t('other.a739');
      } else {
        test = this.$t('other.a740');
      }
      this.$confirm(test, this.$t('other.a142'), {
        confirmButtonText: this.$t('other.a235'),
        cancelButtonText: this.$t('other.a146'),
        type: "warning"
      }).then(() => {
        newOrders
          .updateEmptyOrder({
            emptyOrder: !item.emptyOrder,
            userId: this.userId,
            orderId: item.orderId,
            shopId: item.shopId
          })
          .then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('other.a741'));
              this.initOrderData();
            } else {
              this.$message.warning(res.msg);
            }
          });
      });
    },

    changeOrderInfo(item) {
      console.log(item);
      item.orderPdf = item.orderPdf ? item.orderPdf : {
        pdf: ''
      }
      console.log("===11====")
      let orderItem = JSON.parse(JSON.stringify(item));
      let list = [];
      orderItem.items.forEach(p => {
        if (p.storeItem !== null) {
          p.other = p.itemKey;
          p.itemKey = "DXS|" + p.storeItem.cusCode;
          list.push("DXS|" + p.storeItem.cusCode);
        }
      });
      newOrders.getItemByItemKey(list).then(res => {
        if (res.code === 200) {
          console.log("desc", res.data);
          orderItem.items.forEach(k => {
            if (k.storeItem) {
              let options = res.data[k.itemKey].storeItems.map(i => {
                return {
                  itemKey: "DXS|" + i.cusCode,
                  variationSku: i.skuName,
                  variationName: i.variationName,
                  image: i.image,
                  storeNum: i.storeNum
                };
              });
              console.log(options)
              console.log("====222====")
              k.variationsCopy = options;
            }
          });
          // this.storageOrderInfo(orderItem)
          // this.storageOrderInfoCopy(orderItem)

          utils.updateInfoByCache({
            cacheKey: "orderInfo",
            userId: this.userId,
            cacheData: JSON.stringify(orderItem)
          });

          this.$router.push({
            path: "/changeOrderInfo",
            query: {
              area: "/reviewOrders"
            }
          });
          console.log("852", orderItem);
        } else {
          this.$message.warning(res.msg);
        }
      });

      console.log("list", list);
    },

    showAndhidden(item) {
      let obj = {
        hidden: item.hidden,
        orderId: item.orderId,
        shopId: item.shopId,
        userId: this.userId
      };

      let text = null;

      if (item.hidden) {
        obj.hidden = false;
        text = this.$t('other.a742');
      } else {
        obj.hidden = true;

        text =
          this.$t('other.a743');
      }

      this.$confirm(text, this.$t('other.a142'), {
        confirmButtonText: this.$t('other.a145'),
        cancelButtonText: this.$t('other.a146'),
        type: "warning"
      }).then(() => {
        orderApi.hiddenOrder(obj).then(res => {
          if (res.code === 200) {
            if (item.hidden) {
              this.$message.success(this.$t('other.a744'));
              item.hidden = false;
            } else {
              this.$message.warning(this.$t('other.a745'));
              item.hidden = true;
            }

            this.initOrderData();
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    //创建面单
    createNoodleList(type) {
      console.log(this.orderIdList)
      console.log(this.targetList)
      // return
      if (!this.targetList.length) {
        this.$message.warning('请选择需要进行生成面单的订单')
        return
      }
      let data = []
      for (let i = 0; i < this.targetList.length; i++) {
        data.push({
          "orderId": this.targetList[i].orderId,
          "shopId": this.targetList[i].shopId,
          "type": type,
          "userId": this.targetList[i].userId
        })
      }
      galleryApi.startReadyOrders(data)
        .then(res => {
          if (res.code === 200) {
            console.log('面单地址', res.data)
            this.$message.success(res.msg)
            this.cancelTargetAll()
            this.initOrderData();
          } else {
            this.$message.warning(res.msg)
          }
        })
    },

    //开始生成运单号
    startReadyOrders(num) {
      console.log(this.targetList)
      if (!this.targetList.length) {
        this.$message.warning(this.$t('other.a716'))
        return
      }
      let list = this.targetList.map(p => {
        return {
          orderId: p.orderId,
          shopId: p.shopId,
          type: num,
          userId: this.userId
        }
      })

      // this.targetList.forEach(p => {
      //   this.itemTargetList.push(p.orderId)
      // })

      galleryApi.startReadyOrders(list)
        .then(res => {
          if (res.code === 200) {
            this.isNotify = true
            // 将要轮询的订单号暂存起来
            this.targetList.forEach(p => {
              this.itemTargetList.push(p.orderId)
            })

            console.log(this.itemTargetList)
            this.getNewOrdersInfo(this.itemTargetList)

          } else {
            this.$message.warning(res.msg)
          }
        })

      console.log('list', list)
    },

    //轮询运单号是否生成
    getNewOrdersInfo(list) {
      newOrdersApi
        .getNewOrders(list)
        .then(res => {
          if (res.code === 200) {
            console.log('desc', res.data)
            res.data.forEach(p => {
              if (p.trackingNo) {
                if (this.targetList.length < this.successTotal) {
                  this.successTotal++
                }
                let indexNum = this.itemTargetList.findIndex(item => item == p.orderId)
                console.log(indexNum)
                this.itemTargetList.splice(indexNum, 1)

              }
            })

            console.log(this.itemTargetList)

            setTimeout(() => {
              if (this.itemTargetList.length) {

                this.getNewOrdersInfo(this.itemTargetList)
              } else {
                this.$message.success(this.$t('other.a1007'))
                this.isNotify = false
                setTimeout(() => {
                  this.initOrderData();


                }, 800)
              }

            }, 1000)


          } else {
            this.$message.warning(res.msg)
          }
        })
    },
    createNewOrder() {
      this.$router.push({
        path: "/createNewOrder",
        query: {
          from: "/reviewOrders"
        }
      });
    },

    exportOrderInfo() {
      if (!this.targetList.length) {
        this.$message.warning(this.$t('other.a746'));
        return;
      }
      let text =
        this.$t('other.a747') +
        this.targetList.length +
        this.$t('other.a748');
      this.$confirm(text, this.$t('other.a142'), {
        confirmButtonText: this.$t('other.a749'),
        cancelButtonText: this.$t('other.a146'),
        type: "warning"
      }).then(() => {
        let arr = [];
        this.targetList.forEach(p => {
          p.items.forEach((k, index) => {
            k.totalSku = "";
            k.totalQty = 0;
            let num = index + 1;
            if (k.storeItem && k.storeItem.component) {
              //单品
              k.totalSku =
                "sku1" +
                ":" +
                k.storeItem.skuName +
                " */Qty:" +
                k.variationQuantityPurchased;
              k.totalQty = k.variationQuantityPurchased;
            } else {
              //套餐
              if (k.storeItem && k.storeItem.children) {
                k.storeItem.children.forEach((j, ttb) => {
                  let vdf = ttb + 1;
                  k.totalSku +=
                    "sku" +
                    vdf +
                    "(" +
                    j.cusCode +
                    ")" +
                    ":" +
                    j.skuName +
                    " */Qty:" +
                    k.variationQuantityPurchased * j.rate;
                  k.totalQty += j.rate * k.variationQuantityPurchased;
                });
              }
            }

            arr.push({
              订单号: p.orderId,
              运单号: p.trackingNo,
              收货人: p.address.name,
              电话号码: p.address.phone,
              详细地址:
                p.address.state +
                "/" +
                p.address.city +
                "/" +
                p.address.fullAddress,
              产品名称: k.itemName,
              单品或套餐: k.storeItem
                ? k.storeItem.component
                  ? this.$t('other.a251') + k.storeItem.cusCode
                  : this.$t('other.a252') + k.storeItem.cusCode
                : "未绑定产品",
              sku详情: k.totalSku,
              sku数量: k.storeItem
                ? k.storeItem.component
                  ? 1
                  : k.storeItem.children.length
                : "未绑定产品",
              购买总数: k.totalQty,
              实收: k.price,
              配送方式: p.logistics,
              下单时间: utils.renderTime(p.createTime)
            });
          });
        });

        let list = [
          "订单号",
          "运单号",
          "收货人",
          "电话号码",
          "详细地址",
          "产品名称",
          "单品或套餐",
          "sku详情",
          "sku数量",
          "购买总数",
          "实收",
          "配送方式",
          "下单时间"
        ];

        utils.exPortEXml(arr, list, list);
      });
    },

    //同步订单状态
    Synchronize(num) {
      let start_time = null,
        end_time = null;
      if (num === 3) {
        start_time = utils.getRecentDays(-3);
        end_time = utils.getRecentDays(1);
      } else if (num === 7) {
        start_time = utils.getRecentDays(-6);
        end_time = utils.getRecentDays(1);
      } else if (num === 30) {
        start_time = utils.getRecentDays(-29);
        end_time = utils.getRecentDays(1);
      } else if (num === 90) {
        start_time = utils.getRecentDays(-89);
        end_time = utils.getRecentDays(1);
      }

      let params = {
        end: end_time,
        start: start_time,
        shopIds: null,
        userId: this.userId
      };

      let shopname =
        this.activeShopId == -1
          ? this.$t('other.a750')
          : utils.showShopNameByshopId(this.activeShopId);
      let test =
        this.$t('other.a751') +
        shopname +
        this.$t('other.a752') +
        num +
        this.$t('other.a753');
      this.$confirm(test, this.$t('other.a754'), {
        confirmButtonText: this.$t('other.a755'),
        cancelButtonText: this.$t('other.a146'),
        type: "warning"
      })
        .then(() => {
          let allShopid = JSON.parse(localStorage.getItem("userInfo")).shopIds;
          params.shopIds =
            this.activeShopId == -1 ? allShopid : [this.activeShopId];
          this.$message.warning(this.$t('other.a756'));
          orderApi.updatShopAllOrders(params).then(res => {
            if (res.code === 200) {
              console.log("desc", res.data);
            } else {
              this.$message.warning(res.msg);
            }
          });
          setTimeout(() => {
            this.$message.success(this.$t('other.a757'));
          }, 35000);
        })
        .catch(() => { });


    },
    synchronizeProductsOpen(index) {
      this.synchronizeProductsStatus = index;
      this.synchronizeProductsArr = utils.getAllshop();
      if(this.synchronizeProductsArr.length>0){
        this.synchronizeProductsArr.shift();
      }
      this.synchronizeProductsSKC = '';
      this.synchronizeProductsCheck = this.synchronizeProductsArr.length > 0 ? this.synchronizeProductsArr[0].value : '';
      this.synchronizeProductsShow = true;
    },
    synchronizeProducts() {
      //同步商品
      if (this.synchronizeProductsCheck == '') {
        this.$message.warning('请选择店铺！')
        return
      }
      if (this.synchronizeProductsStatus == 2 && this.synchronizeProductsSKC == '') {
        this.$message.warning('请输入SKCID！')
        return
      }
      let data = {}
      if (this.synchronizeProductsStatus == 1) {
        data = {
          shopId: this.synchronizeProductsCheck,
          userId: this.userId,
        }
      } else {
        let lines = this.synchronizeProductsSKC.split(/\r?\n/);
        data = {
          shopId: this.synchronizeProductsCheck,
          userId: this.userId,
          skcList: lines
        }
      }
      const loading = this.$loading({
        lock: true,
        text: '同步中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.tongBuShopee(data).then(res => {
        loading.close();
        if (res.code === 200) {
          this.$message.success(this.$t('other.a2405'))
          this.synchronizeProductsShow = false;
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        loading.close();
      })
    },

    inPortXml(params) {
      this.loadingTip = 1;
      newOrders.massCreateOrder(params).then(res => {
        if (res.code === 200) {
          console.log("desc", res.data);
          this.loadingTip = 2;
        } else {
          this.$message.warning(res.msg);
        }
      });
    },

    uploadFile(item) {
      console.log("item", item);
      const fileObj = item.file;
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("ordersFile", fileObj);
      form.append("userId", this.userId);
      console.log("form", form);
      this.inPortXml(form);
    },
    beforeUpload(file) {
      const isText = file.type === "application/vnd.ms-excel";
      const isTextComputer =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      if (!isTextComputer) {
        this.$message.warning(this.$t('other.a758'));
      }
      return isTextComputer;
    },
    // 上传文件个数超过定义的数量
    handleExceed(files, fileList) {
      console.log("123");
      this.$message.warning(this.$t('other.a759'));
    },

    getCurence(id) {
      return utils.getCurrency(id);
    },

    //剩余发货时间
    countTime(item) {
      if (!item.shipByDate) {
        return this.$t('other.a354');
      }
      let lasttime = utils.renderTime(item.shipByDate);

      let day = "";
      let hour = "";
      let minute = "";
      let second = "";
      const end = Date.parse(new Date(lasttime));
      const now = Date.parse(new Date());

      if (now >= end) {
        day = 0;
        hour = 0;
        minute = 0;
        second = 0;
        return "0";
      }

      const msec = end - now;
      let d = parseInt(msec / 1000 / 60 / 60 / 24); //算出天数
      let h = parseInt((msec / 1000 / 60 / 60) % 24); //算出小时数
      let m = parseInt((msec / 1000 / 60) % 60); //算出分钟数
      let s = parseInt((msec / 1000) % 60); //算出秒数

      day = d;
      hour = h > 9 ? h : "0" + h;
      minute = m > 9 ? m : "0" + m;
      second = s > 9 ? s : "0" + s;
      const that = this;

      return (
        day +
        this.$t("pendingorder.day") +
        hour +
        this.$t("pendingorder.hours") +
        minute +
        "分"
      );
    },

    // 系统取消订单的剩余时间
    cancelBySystem(time) {
      let timeStamp = Date.parse(new Date(time));
      timeStamp = timeStamp / 1000;
      timeStamp += Number(4) * 86400;
      let newTime = new Date(timeStamp * 1000);
      let d = new Date(newTime);
      let datetime =
        d.getFullYear() +
        "-" +
        (d.getMonth() + 1) +
        "-" +
        d.getDate() +
        " " +
        d.getHours() +
        ":" +
        d.getMinutes() +
        ":" +
        d.getSeconds();
      return utils.countTime(utils.renderTime(newTime));
    },
    showShopNameByshopId(id) {
      let desc = utils.showShopNameByshopId(id);
      return desc == this.$t('other.a354') ? this.$t('other.a760') : desc;
    }
  }
};
</script>
<style lang="scss" scoped>
.OrderForm {
  margin-bottom: 100px;

  .oriderPutAway {
    color: #fff;
    font-weight: 550;
    display: inline-block;
    background-color: #67c23a;
    text-align: center;
    border-radius: 8px;
    margin: 5px 0;
    box-sizing: border-box;
    padding: 2px 10px;
  }

  .supplyPrice {
    color: #fff;
    font-weight: 550;
    display: inline-block;
    background-color: #66b1ff;
    text-align: center;
    border-radius: 8px;
    margin: 5px 0;
    box-sizing: border-box;
    padding: 2px 10px;
  }

  .diaOrder {
    display: flex;

    .mnjh {
      width: 100%;
      box-sizing: border-box;
      padding: 5px;
    }

    .plmk {
      text-align: center;
      padding: 10px 0;
    }

    .klij {
      color: rgb(42, 165, 21);
    }

    .uyhkg {
      color: rgb(255, 164, 61);
    }
  }

  .colng {
    display: flex;
    align-items: center;
    margin-left: 30px;
    font-size: 18px;
    cursor: pointer;
    color: #f56c6c;
  }

  img {
    width: 100%;
  }

  .okngjkg {
    display: flex;
    margin: 10px 0;
    align-items: center;
  }

  .onmbg {
    font-size: 16px;
    font-weight: bold;
    margin-right: 30px;
  }

  .notEnough {
    color: #fff;
    background-color: rgb(255, 97, 97);
    box-sizing: border-box;
    padding: 5px 8px;
    border-radius: 3px;
  }

  .bind {
    color: #409eff;
    box-sizing: border-box;
    padding: 5px 0px;
    border-radius: 5px;
    cursor: pointer;
  }

  .ongk {
    color: #8c8c8c;
    display: flex;
    margin-top: 10px;
    font-size: 12px;
    align-items: center;
  }

  .sensitive {
    color: #fff;
    background-color: rgb(244, 140, 24);
    box-sizing: border-box;
    padding: 5px 8px;
    border-radius: 3px;
  }

  .distributionClass {
    color: #fff;
    background-color: #67c23a;
    box-sizing: border-box;
    padding: 5px 8px;
    border-radius: 3px;
    font-size: 400;
  }

  .midlng {
    margin: 10px 0;
    padding: 0 5px;
  }

  .massCreateWrapper {
    text-align: center;
    margin: 20px 0;
  }

  .el-icon-upload {
    font-size: 75px;
    color: #409eff;
  }

  .masscreateTip {
    text-align: center;
  }

  .dsfdfsf {
    display: flex;
    justify-content: space-between;
  }

  .oningkv {
    box-sizing: border-box;
    padding: 5px 10px;
  }

  .imgbox {
    width: 80px;
    height: 80px;
    overflow: hidden;
    border: 1px solid #eee;
  }

  .orderId {
    background-color: #f6f6f6;
    font-size: 16px;
    font-weight: bold;
    padding: 5px 5px;
  }

  .quatity {
    margin-left: 20px;
  }

  .njngc {
    margin: 0 25px 0 8px;
  }

  .specialpp {
    color: #666 !important;
    font-weight: bold;
    box-sizing: border-box;
    padding-bottom: 5px 0 !important;
  }

  .el-dropdown {
    margin-left: 10px;
  }

  .storeItemBox {
    width: 350px;
    color: red;
  }

  .childreBox {
    display: flex;
    margin-bottom: 14px;

    .skuBox {
      width: 200px;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      color: #666;
    }
  }

  .ttpItem {
    width: 310px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    color: #666;
  }

  .bhbvg {
    text-align: center;
  }

  .eddfj {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .orderArea {
    .order-list-item {
      position: relative;
      padding-bottom: 10px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      margin-bottom: 10px;
    }

    .pic-box {
      display: flex;
      flex-direction: column;
      margin: 2px;
      width: 80px;
      height: 80px;
    }

    .return-item-list {
      display: flex;
      align-items: flex-start;
      margin: 5px 0;
      border-bottom: 1px solid #eee;
    }

    .retrun-reasonr {
      margin-left: 30px;
    }

    .return-item {
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;
      padding: 10px;
    }

    .pic-box-desc {
      width: 400px;
      margin-left: 20px;
    }

    .desck {
      font-size: 14px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      color: #666;
      font-weight: bold;
    }

    .pping {
      flex: 1;
    }

    .retrun-reasonr-btn {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
    }

    .seller {
      margin-right: 10px;
      font-size: 16px;
      font-weight: bold;
    }

    .seller-item {
      margin-left: 15px;
      font-size: 14px;
    }

    .list-desc {
      display: flex;
      align-items: center;
      padding: 5px 0;
      margin-left: 5px;
      border-bottom: 1px #eee solid;
    }

    .btnBox {
      min-width: 150px;
      margin-bottom: 5px;
    }

    .storeItemWrpper {
      margin-bottom: 3px;
    }

    .jinmg {
      margin-top: 10px;
    }

    .bind {
      color: #409eff;
      margin-left: 20px;
      cursor: pointer;
    }

    .icon-tuihuo2 {
      color: #f56c6c;
      font-size: 20px;
      margin-right: 10px;
    }
  }
}

.notify-boxw {
  width: 330px;
  height: 80px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
  position: fixed;
  top: 80px;
  right: 30px;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 10px;
  z-index: 999999;
  background: #ffff;
}

.avatar-uploader {
  position: relative;
}

.avatar-uploader img {
  width: 120px;
  height: 120px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
  border: 1px dashed #66b1ff;
}

.el-icon-error {
  font-size: 20px;
  color: red;
  position: absolute;
  right: 10px;
  top: 10px;
}

.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
</style>